import { useLoadScript } from "@react-google-maps/api"

interface UseGoogleMapsValue {
  googleMaps: typeof window.google.maps | undefined
  isLoaded: boolean
}
/**
 * The useGoogleMaps service/hook loads google maps api
 *
 * @returns isLoaded and google maps api handler
 * @example
 * const {
 *   isLoaded, googleMaps
 * } = useGoogleMaps()
 */
export const useGoogleMaps = (): UseGoogleMapsValue => {
  let googleMaps = undefined

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY ?? "",
  })

  if (isLoaded) {
    googleMaps = window.google.maps
  }

  return { isLoaded, googleMaps }
}
